import { useQuery, useMutation } from "react-query";
import {
  getDocsFromMyDocs,
  getReminderFromReminderAPI,
  getReminderFromMyDocs,
  addReminderOnReminderAPI,
  updateReminderOnReminderAPI,
  updateReminderOnMyDocs,
} from "../api/notificationSchedules";

// Get Document From Mydocs Side
export const useGetDocsFromMyDocs = (projectData, GetDocsFromMyDocsQueryOptions) => {
  return useQuery(
    ["GetDocsFromMyDocsData", projectData],
    () => getDocsFromMyDocs(projectData),
    {
      enabled: !!projectData,
      ...GetDocsFromMyDocsQueryOptions,
    },
  );
};
// Get Reminder From Reminder API
export const useGetReminderFromReminderAPI = (
  findReminderDataSet,
  GetReminderFromReminderAPIQueryOptions,
) => {
  return useQuery(
    ["GetReminderFromReminderAPIData", findReminderDataSet],
    () => getReminderFromReminderAPI(findReminderDataSet),
    {
      ...GetReminderFromReminderAPIQueryOptions,
      enabled: !!findReminderDataSet?.entityId,
      cacheTime: 0,
    },
  );
};

// Get Reminder From myDocs
export const useGetReminderFromMyDocs = (
  findReminderDataSet,
  GetReminderFromMyDocsQueryOptions,
) => {
  return useQuery(
    ["GetReminderFromMyDocsData", findReminderDataSet],
    () => getReminderFromMyDocs(findReminderDataSet),
    {
      ...GetReminderFromMyDocsQueryOptions,
      enabled: !!findReminderDataSet?.entityId,
      cacheTime: 0,
    },
  );
};

// Add Reminder On Reminder API
export const useAddReminderOnReminderAPI = (QueryOptions) => {
  return useMutation(addReminderOnReminderAPI, QueryOptions);
};

// Update Reminder On Reminder API
export const useUpdateReminderOnReminderAPI = (QueryOptions) => {
  return useMutation(updateReminderOnReminderAPI, QueryOptions);
};

// Update Reminder On Mydocs
export const useUpdateReminderOnMyDocs = (QueryOptions) => {
  return useMutation(updateReminderOnMyDocs, QueryOptions);
};

export default {
  useGetDocsFromMyDocs,
  useGetReminderFromReminderAPI,
  useGetReminderFromMyDocs,
  useAddReminderOnReminderAPI,
  useUpdateReminderOnReminderAPI,
  useUpdateReminderOnMyDocs,
};
